//event.target.value
//onChange (event)


import { useState } from "react";

function Greetings () {
    const [name, setName] = useState("");

    return(
        <section>
            <h2>Welcome Miss {name}</h2>
            <input type="text" placeholder="Enter your name" onChange={(event) => setName(event.target.value)}/>
        </section>
    )
}

export default Greetings;

